var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6867 12.6818C10.57 12.6702 10.43 12.6702 10.3017 12.6818C7.52501 12.5885 5.32001 10.3135 5.32001 7.5135C5.32001 4.65516 7.63001 2.3335 10.5 2.3335C13.3583 2.3335 15.68 4.65516 15.68 7.5135C15.6683 10.3135 13.4633 12.5885 10.6867 12.6818Z",
    stroke: "#2C3941",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.145 4.6665C21.4083 4.6665 23.2283 6.49817 23.2283 8.74984C23.2283 10.9548 21.4783 12.7515 19.2967 12.8332C19.2033 12.8215 19.0983 12.8215 18.9933 12.8332",
    stroke: "#2C3941",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.85334 16.9865C2.03001 18.8765 2.03001 21.9565 4.85334 23.8348C8.06167 25.9815 13.3233 25.9815 16.5317 23.8348C19.355 21.9448 19.355 18.8648 16.5317 16.9865C13.335 14.8515 8.07334 14.8515 4.85334 16.9865Z",
    stroke: "#2C3941",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3967 23.3335C22.2367 23.1585 23.03 22.8202 23.6833 22.3185C25.5033 20.9535 25.5033 18.7018 23.6833 17.3368C23.0417 16.8468 22.26 16.5202 21.4317 16.3335",
    stroke: "#2C3941",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.4f61d222b1d2f221e7b97a64b201c2f1.svg";
export { ForwardRef as ReactComponent };